"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class RemainingCreditModelReseller {
    static getAttributeTypeMap() {
        return RemainingCreditModelReseller.attributeTypeMap;
    }
}
RemainingCreditModelReseller.discriminator = undefined;
RemainingCreditModelReseller.attributeTypeMap = [
    {
        "name": "sms",
        "baseName": "sms",
        "type": "number"
    },
    {
        "name": "email",
        "baseName": "email",
        "type": "number"
    }
];
exports.RemainingCreditModelReseller = RemainingCreditModelReseller;
//# sourceMappingURL=remainingCreditModelReseller.js.map